import React, { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { useApp } from "../contexts/AppContext";

// Direct language entry points (/pt, /br, /en): set + confirm the language so the
// visitor bypasses the language-selection splash, then land on the homepage.
export default function LangEntry({ lang, to = "/" }) {
  const { confirmLang } = useApp();
  const [ready, setReady] = useState(false);
  useEffect(() => {
    confirmLang((lang || "pt").toLowerCase());
    setReady(true);
  }, [lang, confirmLang]);
  return ready ? <Navigate to={to} replace /> : null;
}
